module.exports = __webpack_public_path__ + "static/media/results_creating_charts.c99a6be2.png";